import { ApiService } from 'src/services/core';
import VwReferansDoktorDTO from "src/models/GenelTanimlar/VwReferansDoktorDTO";

class ReferansDoktorService {
    private service: ApiService<VwReferansDoktorDTO>
    constructor() {
        this.service = new ApiService<VwReferansDoktorDTO>('VwReferansDoktorDTO');
    }

    createUpdate = (data: VwReferansDoktorDTO) => {
        if (data.id > 0)
            return this.service.update(data)
        else return this.service.create(data)
    }

    getReferansDoktor = (pasifGosterme: boolean) => {
        if (!pasifGosterme)
            return this.service.find({})
        return this.service.find({
            filters: {
                groupOperator: "and",
                predicates: [
                    { fieldName: "aktif", operator: "=", value1: "E" }
                ]
            }
        })
    }
    deleteRecord = (id: number) => {
        return this.service.delete(id);
    }
}

export default new ReferansDoktorService();